import HubspotIcon from "assets/icons/integrations/hubspot.svg?react";
import InstantlyIcon from "assets/icons/integrations/instantly.svg?react";
import MakeIcon from "assets/icons/integrations/make.svg?react";
import McpIcon from "assets/icons/integrations/mcp.svg?react";
import N8nIcon from "assets/icons/integrations/n8n.svg?react";
import PabblyIcon from "assets/icons/integrations/pabbly.svg?react";
import PipedriveIcon from "assets/icons/integrations/pipedrive.svg?react";
import SlackIcon from "assets/icons/integrations/slack.svg?react";
import SmartleadIcon from "assets/icons/integrations/smartlead.svg?react";
import ZapierIcon from "assets/icons/integrations/zapier.svg?react";

export const INTEGRATIONS_LIST = [
  {
    title: "HubSpot",
    description: "Automatically sync Leads data to your HubSpot CRM",
    icon: HubspotIcon,
    key: "hubspot",
  },
  {
    title: "Pipedrive",
    description: "Automatically sync Leads data to your Pipedrive CRM",
    icon: PipedriveIcon,
    key: "pipedrive",
  },
  {
    title: "Zapier",
    description:
      "Integrate Aimfox with over 6000 other apps by using our official Zapier integration",
    icon: ZapierIcon,
    redirectUrl: "https://zapier.com/apps/aimfox/integrations",
  },
  {
    title: "Pabbly",
    description:
      "Integrate Aimfox with a plethora of other tools and automation's with Pabbly",
    icon: PabblyIcon,
    redirectUrl: "https://www.pabbly.com/connect/integrations/aimfox/",
  },
  {
    title: "Make",
    description:
      "Connect Aimfox to your Make.com account and automate powerful workflows",
    icon: MakeIcon,
    redirectUrl: "https://www.make.com/en/integrations/aimfox",
  },
  {
    title: "Slack",
    description:
      "Get real time updates for your Aimfox campaigns, events and notifications directly in Slack",
    icon: SlackIcon,
    redirectUrl:
      "https://slack.com/oauth/v2/authorize?client_id=213198520080.8710595013041&scope=chat:write,commands,incoming-webhook&user_scope=&state=",
  },
  {
    title: "Instantly",
    description:
      "Connect Aimfox with Instantly to build a seamless multi-channel outreach pipeline",
    icon: InstantlyIcon,
    key: "instantly",
  },
  {
    title: "Smartlead",
    description:
      "Connect Aimfox with Smartlead to build a seamless multi-channel outreach pipeline",
    icon: SmartleadIcon,
    key: "smartlead",
  },
  {
    title: "n8n",
    description:
      "Unlock the full potential of Aimfox and n8n's automation platform",
    icon: N8nIcon,
    redirectUrl: "https://n8n.io/integrations/aimfox/",
  },
  {
    title: "MCP Server",
    description: "Control your LinkedIn outreach with AI agents",
    icon: McpIcon,
    redirectUrl:
      "https://help.aimfox.com/en/articles/13051648-aimfox-mcp-server",
  },
] as const;
